import { gql } from '@apollo/client';

export const GET_CALL_LOGS = gql`
  query GET_CALL_LOGS($incidentId: ID!, $originatorId: ID!){
    initialCallInfo(incidentId: $incidentId, originatorId: $originatorId) {
      __typename
      id
      logEntries {
        id
        createdAt
        deptAttribute {
          badge
          ori {
            id
            oriName
            abbreviation
          }
        }
        logCode {
          name
        }
        logEntry
      }
    }    
  }
`